import axios from "axios";
import { GridColDef,GridPreProcessEditCellProps } from '@mui/x-data-grid';
import EmailInputCell from "components/EditableGrid/EmailInputCell";
import PasswordInputCell from "components/EditableGrid/PasswordInputCell";
import "i18n/config";
import i18next from "i18next";

export const get = async (row?:any) => {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/users");
    return response.data;
};

export const update = async (row:any, masterRow?:any) => {
    let response = null;
    if(!row.id) {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/user/store",row);
    } else {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/user/update/"+row.id,row);
    }
    return response.data;
};

export const destroy = async (id:any) => {
    let response = null;
    response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/user/delete/"+id);
    return response.data;
};

export const getRoles = async () => {
  let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/roles");
  return response.data;
};

export async function getColumns(locale: string) {
  i18next.changeLanguage(locale);
  return [
    { 
      field: 'id', 
      headerName: 'ID', 
      width: 90 
    },
    {
      field: 'name',
      headerName: i18next.t('Name'),
      flex: 1,
      editable: true,
    },
    {
      field: 'email',
      headerName: i18next.t('Email'),
      flex: 1,
      type: 'email',
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const hasError = params?.props.value?.indexOf('@') === -1 || params?.props.value?.indexOf('.') === -1;
        return { ...params.props, error: hasError, message:'Insert e valid email' };
      },
      renderEditCell: EmailInputCell,
      editable: true,
    },
    {
      field: 'password',
      headerName: i18next.t('Password'),
      flex: 1,
      editable: true,
      valueFormatter: (params) => {
        return '********';
      },
      renderEditCell:PasswordInputCell
    },
    {
      field: 'id_organization',
      headerName: i18next.t('Organization'),
      flex: 1,
      editable: true,
      type: 'singleSelect',
      valueOptions: [],
      valueGetter: params => params.row.id_organization || '',
    },
    {
      field: 'id_role',
      headerName: i18next.t('Role'),
      flex: 1,
      editable: true,
      type: 'singleSelect',
      valueOptions: [],
      valueGetter: params => params.row.id_role || '',
    },
  ] as GridColDef[]
};